import { Component, OnInit } from "@angular/core";
import { UntypedFormBuilder } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { FlowQueryModel } from "src/app/models/flowquerymodel";
import { EventEmitterService } from "src/app/Services/event-emitter.service";
import { FlowServiceService } from "src/app/Services/flow-service.service";
import { DataService } from "../service/data.service";

@Component({
  selector: "app-show-permissions",
  templateUrl: "./show-permissions.component.html",
  styleUrls: ["./show-permissions.component.scss"],
})
export class ShowPermissionsComponent implements OnInit {
  adminDashboardModel: any;
  usersPermissionsList: any;
  permissionsList: any = [];
  filters: any[] = [];
  adminUsersPermissionsList: any[] = [];
  superAdminUsersPermissionsList: any[] = [];

  roles: string[] = [
    "Admin",
    "Super Admin",
    "Business",
    "Content Creator",
    "User",
  ];
  selectedRole: string = "";

  validPermissionsMap: {
    [feature: string]: { [permission: string]: boolean };
  } = {};

  features = [
    "Dashboard",
    "Consultations",
    "Donation",
    "Notification",
    "Discount Code",
    "Flow/Bundle",
    "Blog",
  ];
  permissions = ["View", "Create/Edit", "Delete"];

  // To store selected permissions
  selectedPermissions: {
    [feature: string]: { [permission: string]: boolean };
  } = {};

  featurePermissionPairs: { feature: string; permission: string }[] = [];
  role: string;

  constructor(
    public formbuilder: UntypedFormBuilder,
    public router: Router,
    public dialog: MatDialog,
    private toastr: ToastrService,
    private eventEmitterService: EventEmitterService,
    private dataService: DataService,
    private flowService: FlowServiceService
  ) {
    // Initialize permission structure
    this.featurePermissionPairs = [];

    for (let feature of this.features) {
      for (let permission of this.permissions) {
        this.featurePermissionPairs.push({ feature, permission });
      }
    }
  }
  userData: any;
  isLoading: boolean;
  async ngOnInit(): Promise<void> {
    this.userData = JSON.parse(localStorage.getItem("LoggedInUser"));
    if (this.userData) {
      this.role =
        this.userData?.userRole == "User"
          ? this.userData?.userType
          : this.userData.userRole;
      this.permissionsList = JSON.parse(localStorage.getItem("Permissions"));
      console.log(this.permissionsList);
      await this.filterPermissionsBasedOnUserRole();
      // this.GetPermissionsData();
    } else {
      this.router.navigate(["/"]);
    }
  }

  GetPermissionsData(): void {
    this.isLoading = true;
    const flowQueryModel = new FlowQueryModel();
    flowQueryModel.userEmail = this.userData?.emailAddress;
    flowQueryModel.searchString =
      this.userData?.userRole == "User"
        ? this.userData?.userType
        : this.userData.userRole;

    if (flowQueryModel.userEmail) {
      this.flowService
        .getUserPermissionsDetailsByRole(flowQueryModel)
        .subscribe({
          next: (data) => {
            this.permissionsList = data.filter(
              (item) => item.permissions !== null
            );
            this.isLoading = false;
          },
          error: (error) => {
            console.error("Error loading permissions", error);
            this.isLoading = false;
          },
        });
    }
  }

  filterPermissionsBasedOnUserRole() {
    // Reset validPermissionsMap
    this.validPermissionsMap = {};

    // Clear previous selectedPermissions
    this.selectedPermissions = {};

    // Guard: if no permissions loaded or selectedRole empty, just return
    if (!this.permissionsList || !this.permissionsList.length) {
      return;
    }

    // Build maps and selectedPermissions
    for (const feature of this.features) {
      this.validPermissionsMap[feature] = {};
      this.selectedPermissions[feature] = {};
      for (const permission of this.permissions) {
        // Find permission matching feature and permission string
        const perm = this.permissionsList[0].permissions.find(
          (p) => p.feature === feature && p.permission === permission
        );
        const isValid = perm ? !!perm.isValid : false;

        this.validPermissionsMap[feature][permission] = isValid;
        this.selectedPermissions[feature][permission] = isValid; // Update selectedPermissions here
      }
    }
  }
}
